import { CircularProgress, Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import TextField from "component/textField/TextField";
import React from "react";
import { useForm } from "react-hook-form";
import styles from "./CreditCheck.module.css";
import { yupResolver } from "@hookform/resolvers/yup";
import { creditCheckSchema } from "schemas/mortgageApplication/MortgageApplicationSchema";
import InfoIcon from "component/infoIcon/InfoIcon";
import AppDatePicker from "component/inputs/datePicker/DatePicker";

function CreditCheck({ setOpenApplicationForm, loading, onSubmit }) {
  const {
    register,
    watch,
    setValue,
    handleSubmit,
    trigger,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(creditCheckSchema),
  });
  const dob = watch("dob", null);


  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={styles.credit_check}
    >
      {loading ? (
        <div className={styles.progress}>
          <CircularProgress size="100px" thickness={2} />
          <Typography>Performing Credit Check</Typography>
        </div>
      ) : (
        <>
          <div className={styles.icon}>
            <InfoIcon />
          </div>
          <div className={styles.text}>
            <Typography variant="h6">Credit Check Consent</Typography>
            <Typography>
              Do you consent to Stanbic Bank conducting credit checks on you
              from at least 2 credit bureaus as a condition for processing your
              mortgage application, in line with regulatory requirements?
            </Typography>
          </div>

          <div className={styles.field}>
            <TextField
              disablePaste={true}
              watch={watch}
              setValue={setValue}
              numberValidation
              type="text"
              required={true}
              label="BVN"
              placeholder="Insert BVN"
              register={register}
              name="bvn"
              errors={errors}
            />
          </div>
          <div className={styles.field}>
            <AppDatePicker
              required={true}
              errors={errors}
              name="dob"
              label="Date of Birth"
              setValue={setValue}
              value={dob}
              trigger={trigger}
            />
            {/* <TextField
              dateMax={true}
              required={true}
              name="dob"
              errors={errors}
              register={register}
              label="Date of Birth"
              type="date"
            /> */}
          </div>
          <div className={styles.btns}>
            <div className={styles.btn}>
              <AppButton
                border={"1px solid #0089FF"}
                bRadius="6px"
                handleAction={() => {
                  setOpenApplicationForm(false);
                }}
                width={"146px"}
                textColor="#fff"
                btnBg="#CE0000"
                btnText={"Close"}
              />
            </div>

            <div className={styles.btn}>
              <AppButton
                bRadius="6px"
                loading={loading}
                handleAction={handleSubmit(onSubmit)}
                width={"146px"}
                textColor="#FFFFFF"
                btnBg="#0072CE"
                btnText={"Submit"}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default CreditCheck;